import ajaxRequest from './ajax'
import qs from "qs"
//获取播放的 auth
export const get_video_auth = params => {
  return ajaxRequest.get("media/get_video_auth?"+ qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/media.js